import React, {Component} from 'react';
import TextField from '../shared/ppbn-textfield';
import InputMask from 'react-input-mask';

export default class ZipcodeTextField extends Component {

    handleChange(e) {
        if(e.target.value.slice(-1) === '-') {
           e.target.value = e.target.value.slice(0,-1);
        } 

        this.props.onChange(e);
    }

    render () {
        return (
            <TextField
                id={this.props.id}
                type="text"
                value={this.props.value || ""}
                label="Zip"                
                onChange={(e) => this.handleChange(e)}>
                <InputMask
                    mask="99999-9999"
                    maskChar={null}
                    value={this.props.value} />
            </TextField>

        )
    }
}
